import { useContext, useState, useEffect } from 'react';

import Heading from 'components/partials/heading/heading';
import Button from 'components/partials/button/button';
import Loader from 'components/partials/loader/loader';
import FilesDetailsForm from 'containers/admin/clients/client/tabs-components/files-tab/file/forms/file-details-form/file-details-form';

import { FileContext } from 'containers/admin/clients/client/tabs-components/files-tab/file/file';

import type {
  UseFormHandleSubmit,
} from 'react-hook-form';

interface FileFormProps {
  isFormDisabled?: boolean;
  loading?: boolean;
  onCancel: () => void;
  onSubmit: (data: Record<string, unknown>) => void;
  handleSubmit: UseFormHandleSubmit<Record<string, unknown>>;
}

const FileForm = ({
  isFormDisabled,
  loading,
  onCancel,
  onSubmit,
  handleSubmit,
}: FileFormProps): React.JSX.Element => {
  const { control, errors } = useContext(FileContext);
  const [isSaveBtnDisabled, setIsSaveBtnDisabled] = useState<boolean>(false);

  useEffect(() => {
    setIsSaveBtnDisabled(Object.keys(errors ?? {}).length !== 0);
  }, [Object.keys(errors ?? {}).length]);

  return (
    <div className="flex flex-col">
      <Loader loading={!!loading} />
      <Heading variant="h3" customClass="mt-4 block">
        File details
      </Heading>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col w-full"
      >
        <FilesDetailsForm
          customClass="mt-4"
          control={control as never}
          errors={errors ?? {}}
          isFormDisabled={isFormDisabled}
        />
        {!isFormDisabled && (
          <div className="flex justify-end mt-4">
            <Button
              variant="reserve-text"
              size="md"
              onClick={onCancel}
              type="button"
              data-testid="cancel-file-form-button"
            >
              Cancel
            </Button>
            <Button
              disabled={isSaveBtnDisabled}
              variant="brand-filled"
              size="md"
              type="submit"
              data-testid="save-file-form-button"
            >
              Save file
            </Button>
          </div>
        )}
      </form>
    </div>
  );
};

export default FileForm;
